import { render, staticRenderFns } from "./ExtraDetails.vue?vue&type=template&id=162943dd&scoped=true"
import script from "./ExtraDetails.vue?vue&type=script&lang=js"
export * from "./ExtraDetails.vue?vue&type=script&lang=js"
import style0 from "./ExtraDetails.vue?vue&type=style&index=0&id=162943dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162943dd",
  null
  
)

export default component.exports